import {
  getBanners,
  getHomeData,
  getNotifications,
  getOrderCount,
  getOrderCountData,
  getPerformance,
  getPerformanceScore,
  getTopSellData,
  getWarehouse,
  updateNotifications
} from './thunk';

export const builderGetNotifyDetails = (builder: any) => {
  builder.addCase(getNotifications.rejected, (state: any) => {
    state.loadingNotifyDetails = true;
    state.notifyDetailsError = 'خطایی رخ داده است لطفا دوباره تلاش کنید';
    state.notifications = [];
    state.totalScore = 0;
    state.totalScoreHistory = [];
  });
  builder.addCase(getNotifications.pending, (state: any) => {
    state.notifyDetailsError = '';
    state.loadingNotifyDetails = true;
    state.notifications = [];
    state.totalScore = 0;
    state.totalScoreHistory = [];
  });
  builder.addCase(getNotifications.fulfilled, (state: any, action: any) => {
    state.notifyDetailsError = '';
    state.loadingNotifyDetails = false;
    state.notifications = action.payload?.notifications;
    state.totalScore = action.payload?.total_score;
    state.totalScoreHistory = action.payload?.total_score_histories;
  });
};

export const builderUpdateNotifications = (builder: any) => {
  builder.addCase(updateNotifications.rejected, (state: any) => {
    state.updatingNotifications = false;
    state.updatingNotificationsError = 'خطایی رخ داده است لطفا دوباره تلاش کنید';
  });
  builder.addCase(updateNotifications.pending, (state: any) => {
    state.updatingNotifications = true;
    state.updatingNotificationsError = '';
  });
  builder.addCase(updateNotifications.fulfilled, (state: any, action: any) => {
    state.updatingNotifications = false;
    state.updatingNotificationsError = '';
    state.updatingNotificationsSuccess = true;
    state.notifications = state.notifications?.filter(
      (ele: any) => ele.score_title !== action.payload.score_title
    );
    state.totalScore = action.payload?.data?.total_Score;
  });
};

export const builderGetHomeData = (builder: any) => {
  builder.addCase(getHomeData.rejected, (state: any) => {
    state.gettingHomeData = false;
    state.gettingHomeDataError = 'خطایی رخ داده است لطفا دوباره تلاش کنید';
  });
  builder.addCase(getHomeData.pending, (state: any) => {
    state.gettingHomeData = true;
    state.gettingHomeDataError = '';
  });
  builder.addCase(getHomeData.fulfilled, (state: any, action: any) => {
    state.gettingHomeData = false;
    state.gettingHomeDataError = '';
    state.homeData = action.payload;
  });
};

export const builderGetPerformanceScore = (builder: any) => {
  builder.addCase(getPerformanceScore.pending, (state: any) => {
    state.gettingHomeData = true;
    state.gettingHomeDataError = '';
  });
  builder.addCase(getPerformanceScore.fulfilled, (state: any, action: any) => {
    state.performanceScore = action.payload;
  });
  builder.addCase(getPerformanceScore.rejected, (state: any) => {
    state.gettingHomeData = false;
    state.gettingHomeDataError = 'خطایی رخ داده است لطفا دوباره تلاش کنید';
  });
};
export const builderGetOrderCountData = (builder: any) => {
  builder.addCase(getOrderCountData.pending, () => {});
  builder.addCase(getOrderCountData.fulfilled, (state: any, action: any) => {
    state.orderCountData = action.payload;
  });
  builder.addCase(getOrderCountData.rejected, () => {});
};

export const builderGetTopSellData = (builder: any) => {
  builder.addCase(getTopSellData.pending, () => {});
  builder.addCase(getTopSellData.fulfilled, (state: any, action: any) => {
    state.topSellData = action.payload;
  });
  builder.addCase(getTopSellData.rejected, () => {});
};

export const builderWarehouse = (builder: any) => {
  builder.addCase(getWarehouse.pending, () => {});
  builder.addCase(getWarehouse.fulfilled, (state: any, action: any) => {
    state.warehouse = action.payload;
  });
  builder.addCase(getWarehouse.rejected, () => {});
};

export const builderPerformance = (builder: any) => {
  builder.addCase(getPerformance.pending, () => {});
  builder.addCase(getPerformance.fulfilled, (state: any, action: any) => {
    state.performance = action.payload;
  });
  builder.addCase(getPerformance.rejected, () => {});
};

export const builderOrderCount = (builder: any) => {
  builder.addCase(getOrderCount.pending, () => {});
  builder.addCase(getOrderCount.fulfilled, (state: any, action: any) => {
    state.orderCount = action.payload;
  });
  builder.addCase(getOrderCount.rejected, () => {});
};

export const builderGetBanners = (builder: any) => {
  builder.addCase(getBanners.pending, () => {});
  builder.addCase(getBanners.fulfilled, (state: any, action: any) => {
    state.banners = action.payload.data;
  });
  builder.addCase(getBanners.rejected, () => {});
};
